import { render, staticRenderFns } from "./AllBlogsPage.vue?vue&type=template&id=22b234e8&scoped=true&"
import script from "./AllBlogsPage.vue?vue&type=script&lang=js&"
export * from "./AllBlogsPage.vue?vue&type=script&lang=js&"
import style0 from "./AllBlogsPage.vue?vue&type=style&index=0&id=22b234e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b234e8",
  null
  
)

export default component.exports